import styled, { css } from "styled-components";

export const Container = styled.section<{ isCategoryAllowed?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  min-height: ${({ isCategoryAllowed }) =>
    isCategoryAllowed ? "472px" : "457px"};
  border: 1px solid var(--border-default);
  border-radius: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TopMenu = styled.div`
  background-color: var(--analytics-chart-header-bg);
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid var(--border-default);
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const SideMenu = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const LeftSideMenu = styled(SideMenu)`
  justify-content: left;
  font-size: 14px;
  font-weight: 600;
  color: var(--hv-text-normal-secondary);
`;

export const RightSideMenu = styled(SideMenu)`
  justify-content: right;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
  color: var(--hv-text-normal-secondary);

  .select-box {
    border-color: transparent !important;
    background-color: transparent;

    &__disabled {
      background-color: transparent !important;
    }

    .select-icon {
      margin-left: 2px;
    }
  }
`;

export const ChartTypeCheckboxGroup = styled.div`
  text-align: left;
  border-radius: 4px;
  label {
    padding: 9px 0;
  }
`;

export const ChartTypeCheckbox = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
`;

export const ChartTypeLabel = styled.div`
  color: var(--hv-text-normal-secondary);
  padding-left: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
`;

export const ChartTypeDropdown = styled.div`
  position: absolute;
  background-color: var(--legend-background-color);
  border: 1px solid var(--analytics-popup-border-color);
  box-shadow: 0px 2px 4px 0px #00000052;
  color: white;
  padding: 8px 16px 12px;
  border-radius: 8px;
  width: 240px;
  top: 25px;
  right: 0;
  z-index: 2;
  height: 256px;
`;

export const ChartTypeButton = styled.div`
  color: var(--hv-text-normal-secondary);
  font-size: 13px;
  font-weight: 400;
  line-height: 15.51px;
  cursor: pointer;
`;

export const ChartTypeCount = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100px;
  background-color: var(--analytics-chart-count-badge-bg);
  color: var(--analytics-chart-count-badge-text);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 13.13px;
  margin-left: 5px;
  padding: 1.5px 1px 0 0;
`;

export const ChartTypeContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  position: relative;
`;

export const ButtonWrap = styled.div`
  margin-top: 12px;
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const IconWrap = styled.div`
  svg {
    width: 24px;
    height: 24px;
    margin-bottom: -2px;
  }
`;

export const LocationButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 12px 0 8px;
  gap: 4px;
  color: var(--hv-text-normal-secondary);
  svg {
    path {
      fill: var(--hv-text-normal-secondary);
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--text-disabled);
      svg {
        path {
          fill: var(--icon-disabled);
        }
      }
    `}
`;

export const InsightContainer = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  line-height: 20px;
  gap: 2px;
`;
export const InsightButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    path {
      stroke: var(--hv-text-normal-secondary);
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      svg {
        path {
          stroke: var(--icon-disabled);
        }
      }
    `}
`;

export const InsightBeta = styled.span`
  display: flex;
  width: 36px;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--orange-4);
  color: white;
  background-color: var(--orange-4);
  border-radius: 4px;
  font-weight: 700;
`;

export const IconTrophy = styled.img``;

export const MoreButton = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
`;

export const Divider = styled.div`
  height: 100%;
  width: 1px;
  background-color: var(--border-emphasis);
`;

export const LoadingWrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  > div {
    > div {
      top: calc(50% - 40px);
    }
  }
`;

export const LegendItem = styled.div<{ disabled: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--hv-text-normal-secondary);
  padding: 6px 8px;
  border-radius: 4px;

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--text-disabled);
      span {
        background-color: var(--text-disabled) !important;
      }
    `}
`;

export const ChartGraphContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
`;

export const ChartGraphContent = styled.div`
  width: -webkit-fill-available;
  margin-top: 15px;
`;

export const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: Arial, sans-serif;
  font-size: 12px;
`;

export const ToggleAlignment = styled.div<{ center?: boolean }>`
  ${({ center }) =>
    center &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: end;
      & > div:nth-of-type(1) {
        flex: 1;
        justify-content: center;
      }
    `}
`;

export const LegendCircle = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 5px;
`;

export const LegendMore = styled.div`
  cursor: pointer;
  position: relative;
`;

export const LegendButton = styled.button`
  background: transparent;
  padding: 0px 6px 0px 5px;
  height: 24px;
  color: var(--hv-text-normal-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 14.32px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    path {
      fill: var(--hv-text-normal-secondary);
    }
  }
  &:hover {
    background: var(--button-background-color);
  }
`;

export const LegendDropdownItem = styled.div<{ disabled: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  white-space: nowrap;
  color: var(--hv-text-normal-secondary);

  ${({ disabled }) =>
    disabled &&
    css`
      color: var(--text-disabled);
      span {
        background-color: var(--text-disabled) !important;
      }
    `}
`;

export const LegendDropdown = styled.div`
  display: block;
  position: absolute;
  top: 26px;
  left: 0;
  background-color: var(--legend-background-color);
  color: var(--text-primary);
  border: 1px solid var(--legend-border-color);
  border-radius: 5px;
  box-shadow: 0px 2px 4px 0px var(--legend-box-color);
  z-index: 1000;
  min-width: 160px;
  padding: 3px 0px;
  &::-webkit-scrollbar {
    cursor: pointer;
    display: block;
    width: 6px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--background-scroll-thumb);
    border-radius: 3px;
    cursor: auto;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    margin: 8px;
  }

  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
`;

export const ChartWrapContainer = styled.div<{
  hasBorder: boolean;
  separateTimeLines?: boolean;
}>`
  display: flex;
  flex-direction: ${({ separateTimeLines }) =>
    separateTimeLines ? "column" : "row"};
  ${({ hasBorder }) =>
    hasBorder &&
    css`
      border-bottom: 1px solid var(--hv-border-default);
    `}
  ${({ separateTimeLines }) =>
    separateTimeLines &&
    css`
      border-bottom: 1px solid var(--hv-border-default);
    `}
`;

export const ChartDivider = styled.div<{ separateTimeLines?: boolean }>`
  ${({ separateTimeLines }) =>
    separateTimeLines
      ? css`
          border-bottom: 1px solid var(--hv-border-default);
        `
      : css`
          border-right: 1px solid var(--hv-border-default);
        `}
`;
export const ChartWrap = styled.div`
  position: relative;
  min-height: 396px;
  padding: 20px 24px;
  width: 100%;

  > .custom-avg {
    .mrt-table-head-cell-content {
      justify-content: center;
    }
  }
`;

export const InsightContent = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--hv-text-normal-secondary);
`;

export const InsightHeading = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const InsightCategorySwitch = styled.div`
  margin-top: 16px;
`;

export const GraphChartContainer = styled.div`
  height: 212px;
  margin-top: 20px;
`;

export const RetailGraphChartContainer = styled.div`
  height: 279px;
  margin-top: 20px;
`;

export const ChartContainer = styled.div`
  display: inline-block;
  padding-top: 4px;
`;
export const ChartDropdown = styled.div`
  display: flex;
  justify-content: end;
  flex-direction: row;
  margin: 15px 0px 10px 0px;
`;

export const ChartRankPeopleContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  border-radius: 5px;
  border: 1px solid var(--hv-border-default);
  margin-top: 16px;
`;

export const ChartRankPeopleWrap = styled.div<{ borderShow: number }>`
  height: 96px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--hv-text-normal-secondary);
  flex-direction: column;
  text-align: center;
  width: 100px;
  padding: 0px 8px;
  ${({ borderShow }) =>
    borderShow === 3 &&
    css`
      &:nth-child(2) {
        border-left: 1px solid var(--hv-border-default);
        border-right: 1px solid var(--hv-border-default);
      }
    `}
  ${({ borderShow }) =>
    borderShow === 2 &&
    css`
      &:nth-child(2) {
        border-left: 1px solid var(--hv-border-default);
      }
    `}
`;

export const ChartRankPeopleCount = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const ChartRankPeopleLocation = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const Text = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0%;
  color: var(--hv-text-normal-secondary);
`;

export const CursorZoom = styled.div`
  & > div > div {
    cursor: all-scroll !important;
  }
`;
